module.exports = __webpack_public_path__ + "img/sf-socket.85a8e164.jpg";